define("ember-cli-string-helpers/-private/create-string-helper", ["exports", "@ember/template"], function (_exports, _template) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _default;
  function _default(stringFunction) {
    return function (_ref) {
      let [string] = _ref;
      if ((0, _template.isHTMLSafe)(string)) {
        string = string.string;
      }
      string = string || '';
      return stringFunction(string);
    };
  }
});